<template>
    <div>
        <div id="big">
            <div class="bigContainer">
                <div class="modal fade" id="GrantPermissionCourse" tabindex="-1" role="dialog"
                    aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel"><strong>
                                        <i class="fa-solid fa-plus"></i> Cấp quyền khóa học</strong></h5>
                                <button @click="restoreColor()" type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                                    <span aria-hidden="true" class="text-danger"><i
                                            class="fa-regular fa-circle-xmark"></i></span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form @submit.prevent="GrantPermissionCourse()">
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="form-group">
                                                <label class="bold" for="exampleInputPassword1">Doanh thu thực (VNĐ)</label>
                                                <input required v-model="record.revenue" type="text"
                                                    class="form-control" id="exampleInputPassword1"
                                                    placeholder="1.000.000 (VNĐ)">
                                                <span v-if="errors.revenue" class="text-danger">{{
                                                    errors.revenue[0] }}<br></span>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <label class="bold" for="exampleInputPassword1">VAT (%)</label>
                                                <input required v-model="record.vat_percentage" type="text"
                                                    class="form-control" id="exampleInputPassword1" placeholder="8(%)">
                                                <span v-if="errors.vat_percentage" class="text-danger">{{
                                                    errors.vat_percentage[0] }}<br></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="bold">Khóa học</label>
                                        <div class="row p-2 mb-2 ">
                                            <Multiselect v-model="record.course_ids" mode="tags"
                                                placeholder="Chọn học viên" :close-on-select="true" :searchable="true"
                                                :create-option="false" :options="courses" />
                                        </div>
                                        <span v-if="errors.course_ids" class="text-danger">{{ errors.course_ids[0]}}<br></span>
                                        <span v-if="error_message_simple" class="text-danger">{{ error_message_simple }}</span>
                                    </div>
                                    <button type="submit" class="btn-pers" id="login_button"><i
                                            class="fa-solid fa-plus"></i> Cấp quyền</button>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal"
                                    ref="closeButton" @click="restoreColor()" id="close">Đóng</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserRequest from '@/restful/UserRequest';
import Multiselect from '@vueform/multiselect'

export default {
    name: "GrantPermissionCourse",
    props: {
        user_id: String,
        courses: Array,
    },
    setup() {

    },
    data() {
        return {
            selectedFile: null,
            record: {
                user_id: null,
                course_ids: [],
                revenue: 0,
                vat_percentage: 8,
            },
            errors: {
                user_id: null,
                course_ids: null,
                revenue: null,
                vat_percentage: null,
            }, 
            error_message_simple: null,
        }
    },
    mounted() {
    },
    components: {
        Multiselect
    },
    computed: {
    },
    methods: {
        restoreColor: function () {
            // Hiện tại mình vẫn chưa bắt sự kiện click ra ngoài background thì cho nó reset color , chỉ mới bắt sự kiện click 2 button
            // Chờ Bootstrap hoàn tất hiệu ứng modal (fade out) rồi khôi phục màu backdrop
            setTimeout(() => {
                const element = document.getElementById("CourseOfUser");
                if (element) {
                    element.style.backgroundColor = "#0000008a";
                }
            }, 300);
            // delay trùng với hiệu ứng modal Bootstrap (fade)
        },
        GrantPermissionCourse: async function () {
            try {
                this.record.user_id = this.user_id;
                const { messages } = await UserRequest.post('admin/management-user/grant-permission-list-course-for-user', this.record, true);
                this.$emitEvent('eventSuccess', messages[0]);
                for (let key in this.errors) this.errors[key] = null;
                var closePW = window.document.getElementById('GrantPermissionCourse');
                closePW.click();
                this.record.course_ids = [];
                this.error_message_simple = null,
                this.restoreColor();
                this.$emitEvent('eventGetCourseOfUser', this.user_id);
            }
            catch (error) {
                if (error.errors) this.errors = error.errors;
                else for (let key in this.errors) this.errors[key] = null;
                if (error.messages) {
                    this.$emitEvent('eventError', error.messages[0]);
                    this.error_message_simple = error.messages[0];
                }
            }

        },
    },
    watch: {

    },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped src="@/components/modal-responsive.css"></style>
<style scoped>
/* image upload */
.big-container-image {
    display: flex;
    align-items: center;
    align-content: center;
    /* height: 100%; */
}

.inner-image-upload {
    height: 50%;
    width: 100%;
}

.min-image-upload {
    background-color: #e9ecef;
    position: relative;
    text-align: center;
    /* width: 170px; */
    height: 170px;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.5s ease;
    width: 100%;
}

.min-image-upload .preview {
    /* width: 150px; */
    height: 150px;
    object-fit: cover;
    border-radius: 6px;
    cursor: default;
    width: 100%;
}

.min-image-upload:hover {
    transition: all 0.5s ease;
    background: #E8F5E9;
}

.input-file {
    opacity: 0;
    top: 0px;
    left: 0px;
    position: absolute;
    cursor: pointer;
    /* width: 150px; */
    height: 150px;
    width: 100%;
}

.box-preview {
    position: relative;
}

.iconClound {
    cursor: pointer;
    font-size: 60px;
    color: var(--user-color);
}

.close-img {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 16px;
}

/* image upload */


/*  */
.modal-dialog {
    max-width: 800px;
}

/*  */


.modal.fade.show {
    padding-left: 0px;
}

.modal-content {
    /* margin-top: 100px; */
    border-radius: 10px;
}

.bigContainer .input-form {
    height: 40px;
    width: 100%;
    position: relative;
}

.bigContainer .input-form input {
    height: 100%;
    width: 100%;
    border: none;
    font-size: 17px;
    border-bottom: 2px solid silver;
    outline: none !important;
}

.input-form input:focus~label,
.input-form input:valid~label {
    transform: translateY(-20px);
    font-size: 15px;
    color: var(--user-color);
}

.input-form .underline.fix2:before {
    position: absolute;
    content: "";
    height: 100%;
    width: 100%;
    background: var(--user-color);
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease;
}

.bigContainer .input-form label {
    position: absolute;
    bottom: 0px;
    left: 0;
    color: grey;
    pointer-events: none;
    transition: all 0.3s ease;
}

.input-form .underline {
    position: absolute;
    height: 2px;
    width: 100%;
    bottom: 0;
}

.input-form .underline:before {
    position: absolute;
    content: "";
    height: 100%;
    width: 100%;
    background: var(--user-color);
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease;
}

.input-form input:focus~.underline:before,
.input-form input:valid~.underline:before {
    transform: scaleX(1);
}

@import url('https://fonts.googleapis.com/css2?family=Reem+Kufi+Ink');

#big {
    display: flex;
    position: relative;
}

.btn-pers {
    position: relative;
    left: 50%;
    padding: 1em 2.5em;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    font-weight: 700;
    color: #000;
    background-color: #fff;
    border: none;
    border-radius: 45px;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease 0s;
    cursor: pointer;
    outline: none;
    transform: translateX(-50%);
}

.btn-pers:hover {
    background-color: var(--user-color);
    box-shadow: var(--btn-hover);
    color: #fff;
    transform: translate(-50%, -7px);
}

.btn-pers:active {
    transform: translate(-50%, -1px);
}

#inputPassword {
    padding-right: 26px;
}
</style>
